<mat-card appearance="outlined" class="p-4 mb-1">
    <h4>Reservation Details</h4>
    <div class="mt-2">
        @if(reservation?.claim_id) {
            <div class="info-row">
                Claim ID: 
                <span class="text-bold">
                    {{ reservation?.claim_id }}
                </span>
            </div>
        }
        <div class="info-row">
            Reservation ID: 
            <span class="text-bold" (click)="onGoToReservationClick()">
                <a>{{ reservation?.reservation_reference_id }}</a>
            </span>
        </div>
        <div class="info-row">
            Safely Res. ID: 
            <span class="text-bold">
                {{ reservation?.reservation_id }}
            </span>
        </div>
        <div class="info-row">
            Arrival Date: 
            <span class="text-bold">
                {{ dateFormat(reservation?.arrival_date, userContextProvider.region) }}
            </span>
        </div>
        <div class="info-row">
            Departure Date: 
            <span class="text-bold">
                {{ dateFormat(reservation?.departure_date, userContextProvider.region) }}
            </span>
        </div>
        <div class="info-row">
            Property Name: 
            <span class="text-bold" (click)="onGoToPropertyClick()">
                <a>{{ reservation?.property?.property_name }}</a>
            </span>
        </div>
        <div class="info-row">
            Property Address: 
            <span class="text-bold">
                {{ formattedPropertyAddress$ | async }}
            </span>
        </div>
        <div class="info-row">
            Guest Name: 
            <span class="text-bold" (click)="onGoToGuestClick()">
                <a>{{ reservation?.guests?.[0]?.first_name }} {{ reservation?.guests?.[0]?.last_name }}</a>
            </span>
        </div>
    </div>
</mat-card>